import {
  InbodyType,
  humanizeInbodyType,
} from '../../../constants/inbody-info/InbodyType';

export const getHumanizeInbodyType = (inbodyType: InbodyType): string => {
  return humanizeInbodyType[inbodyType] ?? inbodyType;
};
